@if (!claimSubmissionCompleted) {
  <div class="SubmitClaims__Main">
    @if (currentPage === 'instructionsPage') {
      <zip-claim-submission-instructions
        [config]="instructionConfig"
        (cancelInstructions)="cancelInstructions()"
        (confirmInstructions)="confirmInstructions()"
      ></zip-claim-submission-instructions>
    }
    @if (currentPage === 'confirmationPage') {
      <lib-confirmation-page
        [config]="confirmationPageConfig"
        [claimId]="claimSubmissionService.claimId"
        (viewSubmittedClaimInformation)="viewSubmittedClaim()"
        data-test-id="confirmationPageComponent"
      ></lib-confirmation-page>
    }
    @if (currentPage === 'form') {
      <div class="SubmitClaims__Tabs">
        <div class="SubmitClaims__MobileHeader">
          <accordion [config]="mobileHeaders">
            <ul class="SubmitClaimsTabs__Wrapper">
              @for (tab of allTabs; track tab; let i = $index) {
                <li
                  [attr.data-test-id]="tab.tabLabel.text"
                  class="Vertical__Step SubmitClaimsTabs__WrapperItem"
                  [ngClass]="{
                    Active: selectedTabIndex === i,
                  }"
                >
                  {{ tab.tabLabel.text }}
                </li>
              }
            </ul>
          </accordion>
        </div>
        <tabs
          [tabLabels]="tabLabels"
          [showAsBreadcrumbs]="true"
          [selectedIndex]="selectedTabIndex"
          (tabSelected)="setActiveTab($event)"
        >
          @for (tab of config?.tabs | keyvalue: keepOrder; track tab) {
            <div *templateRef class="SubmitClaims__Layout">
              @if (tab) {
                @switch (tab.key) {
                  @case ('claimSubmission') {
                    @if (
                      claimSubmissionHttpService.saveClaimBannerConfig$ | async;
                      as bannerConfig
                    ) {
                      <message-banner
                        [config]="bannerConfig"
                        (actionClicked)="closeSaveClaimsBanner()"
                        data-test-id="saveClaimMessageBanner"
                      ></message-banner>
                    }
                    <div class="SubmitClaims__TabsHeader">
                      <h4 class="u-textCenter HideIn__MobileView">
                        {{ tab.value?.tabLabel?.text }}
                      </h4>
                      <p
                        class="u-textCenter"
                        [innerHTML]="tab.value?.tabLabel?.subHeading"
                      ></p>
                    </div>
                    <zip-claim-submission-forms
                      [config]="config"
                      [submittedClaimContext]="submittedClaimContext"
                      (formValueChanged)="formValueUpdated($event)"
                    ></zip-claim-submission-forms>
                  }
                  @case ('review') {
                    <div class="SubmitClaims__TabsHeader">
                      <h4 class="u-textCenter">
                        {{ tab.value?.tabLabel?.text }}
                      </h4>
                    </div>
                    <lib-claim-submission-review
                      [config]="config"
                      (certificationFormValueChanged)="
                        certificationFormValueUpdated($event)
                      "
                      [totalClaimLineCharges]="totalClaimLineCharges"
                      (editIconClickedEmitter)="editIconClickedEmitter($event)"
                    ></lib-claim-submission-review>
                  }
                }
              }
            </div>
          }
        </tabs>
      </div>
    }
    @if (currentPage === 'form') {
      <lib-claim-submission-footer
        [selectedTabIndex]="selectedTabIndex"
        [footerConfig]="footerConfig"
        [ifFormValid]="
          !(
            claimSubmitForm.valid &&
            claimSubmissionService.uploadedFiles.length > 0
          )
        "
        [totalClaimLineCharges]="totalClaimLineCharges"
        [submitButtonEnabled]="submitButtonEnabled"
        (footerButtonClicked)="footerButtonClicked($event)"
      ></lib-claim-submission-footer>
    }
  </div>
} @else {
  <lib-claim-submission-summary
    [config]="config"
    [claimNumber]="claimSubmissionService.claimNumber"
    [claimId]="claimSubmissionService.claimId"
    [submittedClaimContext]="submittedClaimContext"
  ></lib-claim-submission-summary>
}
